import { fromJS, List } from 'immutable';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';

export const USER_REDUCER_KEY = 'userReducer';

export const LOAD_MY_FUNDRAISERS = 'LOAD_MY_FUNDRAISERS';

export const PUT_AND_HANDLE_USER = 'PUT_AND_HANDLE_USER';
export const RESET_USER_REDUCER = 'RESET_USER_REDUCER';
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const LOAD_LOGIN_ERROR = 'LOAD_LOGIN_ERROR';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_USER_REDUCER = 'SET_USER_REDUCER';
export const SET_AUTH_0_AUTHENTICATION = 'SET_AUTH_0_AUTHENTICATION';

// TODO: make two reducers, one myReducer which store the logged in users fundraisers, and one sessionStateReducers where we store userInfo and accessToken (struff from auth0)

let defaultState = fromJS({
  accessToken: null,
  isAuth0Authenticated: null,
  userInfo: null,
  fundraisers: null,
});

export default function (state = defaultState, action = {}) {
  switch (action.type) {
    case SET_USER_REDUCER: {
      const imPayload = fromJS(action.payload);
      const userInfo = getIn(imPayload, 'userInfo');

      const permissionEmail = isSignedInWithEmail(userInfo)
        ? 'EMAIL'
        : undefined;

      const permissions = permissionEmail && List([permissionEmail]);

      const userInfoWithPermissions =
        userInfo && userInfo.set('permissions', permissions);

      return state.merge({
        accessToken: action.payload && action.payload.accessToken,
        isAuth0Authenticated:
          action.payload && action.payload.isAuth0Authenticated,
        userInfo: userInfoWithPermissions,
      });
    }
    case PUT_AND_HANDLE_USER: {
      return state
        .setIn(['userInfo', 'given_name'], action.payload.given_name)
        .setIn(['userInfo', 'family_name'], action.payload.family_name)
        .setIn(['userInfo', 'email'], action.payload.email);
    }
    case SET_USER_INFO: {
      return state.merge({ userInfo: action.payload });
    }
    case LOAD_MY_FUNDRAISERS: {
      const fundraisers =
        action.payload != null ? fromJS(action.payload) : null;
      return state.merge({ fundraisers });
    }
    case SET_AUTH_0_AUTHENTICATION: {
      return state.merge({ isAuth0Authenticated: action.payload });
    }
    case SET_ACCESS_TOKEN: {
      return state.set('accessToken', action.payload);
    }
    case RESET_USER_REDUCER: {
      return defaultState;
    }
    case LOAD_LOGIN_ERROR: {
      return state.setIn(['errors', 'loginError'], action.error);
    }
    default:
      return state;
  }
}

export const selectAccessToken = (state) => {
  return getIn(state[USER_REDUCER_KEY], 'accessToken');
};

export const selectIsAuth0Authenticated = (state) => {
  return getIn(state[USER_REDUCER_KEY], 'isAuth0Authenticated');
};

// user
export const selectUserInfo = (state) => {
  return getIn(state[USER_REDUCER_KEY], 'userInfo');
};

export const selectMyFundraisers = (state) => {
  return getIn(state[USER_REDUCER_KEY], 'fundraisers');
};

export const selectUserPermissions = (state) => {
  return getIn(selectUserInfo(state), 'permissions');
};

export const selectIsSignedInWithEmail = (state) => {
  return isSignedInWithEmail(getIn(state[USER_REDUCER_KEY], 'userInfo'));
};

export const selectUserRoles = (state) => {
  return getIn(state[USER_REDUCER_KEY], 'userInfo', 'http://hlf.se/roles');
};

// Util functions
export const isSignedInWithEmail = (userInfo) => {
  const sub = getIn(userInfo, 'sub');
  return sub && sub.startsWith('auth0');
};
